define("media/controllers/edit", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/tracking", "ember-concurrency", "nprogress", "later/utils/constants", "shared/utils/delete-media-item", "shared/utils/uuid"], function (_exports, _asyncArrowRuntime, _controller, _object, _computed, _service, _tracking, _emberConcurrency, _nprogress, _constants, _deleteMediaItem, _uuid) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _savedCaptionSegmentEvent;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"nprogress",0,"later/utils/constants",0,"shared/utils/delete-media-item",0,"shared/utils/uuid"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let EditController = _exports.default = (_dec = (0, _service.inject)('schedule/caption-hashtags'), _dec2 = (0, _computed.alias)('model'), (_class = (_savedCaptionSegmentEvent = /*#__PURE__*/new WeakSet(), class EditController extends _controller.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _savedCaptionSegmentEvent);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "mediaLabels", _descriptor5, this);
      _initializerDefineProperty(this, "mediaNavigation", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
      _initializerDefineProperty(this, "scheduleCaptionHashtags", _descriptor8, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor9, this);
      _initializerDefineProperty(this, "segment", _descriptor10, this);
      _initializerDefineProperty(this, "starredMedia", _descriptor11, this);
      _initializerDefineProperty(this, "store", _descriptor12, this);
      _initializerDefineProperty(this, "editingCaption", _descriptor13, this);
      _initializerDefineProperty(this, "savedCaptionToEdit", _descriptor14, this);
      _initializerDefineProperty(this, "mediaItem", _descriptor15, this);
      _defineProperty(this, "uniqueId", (0, _uuid.default)());
      _defineProperty(this, "addNewLabel", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (label, labelList, createdFromLabelMedia) {
          try {
            yield this.mediaLabels.addNewLabel.perform(label, labelList, createdFromLabelMedia);
            this.mediaItem.save();
          } catch (error) {
            this.errors.handleAdapter(error, this.mediaItem);
          }
        }
      }), null, "addNewLabel", "drop"));
      _defineProperty(this, "cancelEditingCaption", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.mediaItem.rollbackAttributes();
          this.editingCaption = false;
          this.secondaryModal.removeModal();
        }
      }), null, "cancelEditingCaption", null));
      _defineProperty(this, "closeModal", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.hasDirtyAttributes) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_items.update.close_save'));
            if (!didConfirm) {
              return;
            }
            yield this.mediaItem.save();
          } else if (this.savedCaptionToEdit?.isNew || this.savedCaptionToEdit?.hasDirtyAttributes) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_items.update.close_save'));
            if (!didConfirm) {
              return;
            }
            yield this.savedCaptionToEdit.save();
            if (this.savedCaptionToEdit.get('isNew')) {
              _classPrivateMethodGet(this, _savedCaptionSegmentEvent, _savedCaptionSegmentEvent2).call(this, 'saved-new-caption', this.savedCaptionToEdit.title);
            }
            this.savedCaptionToEdit = null;
          } else {
            this.mediaItem.rollbackAttributes();
          }
          if (this.hasSecondary) {
            this.toggleSecondary('', 'media_item');
          }
          this.editingCaption = false;
          this.router.transitionTo('cluster.media');
        }
      }), null, "closeModal", null));
      _defineProperty(this, "deleteLabel", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (label) {
          yield this.mediaLabels.deleteLabel(label);
        }
      }), null, "deleteLabel", "drop"));
      _defineProperty(this, "deleteMediaItem", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_items.update.confirm_destroy'), {
            description: this.intl.t('media_items.update.confirm_destroy_posts'),
            confirmButton: this.intl.t('shared_words.delete')
          });
          if (!didConfirm) {
            return;
          }
          this.starredMedia.removeStarred(this.mediaItem);
          try {
            _nprogress.default.start();
            yield (0, _deleteMediaItem.default)(this.mediaItem);
            this.router.transitionTo('cluster.media');
            _nprogress.default.done();
          } catch (error) {
            this.errors.log(error);
          }
        }
      }), null, "deleteMediaItem", "drop"));
      _defineProperty(this, "rollbackSavedCaption", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            if (this.savedCaptionToEdit?.isNew) {
              yield this.savedCaptionToEdit.deleteRecord();
            } else if (this.savedCaptionToEdit?.hasDirtyAttributes) {
              yield this.savedCaptionToEdit.rollbackAttributes();
            }
            this.savedCaptionToEdit = null;
          } catch (error) {
            this.errors.handleAdapter(error, {});
          }
        }
      }), null, "rollbackSavedCaption", null));
      _defineProperty(this, "saveEditedCaption", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            yield this.mediaItem.save();
            this.segment.track('updated-media-notes', {
              group_id: this.currentGroup?.id || null,
              media_id: this.mediaItem.id,
              media_url: this.mediaItem.isVideo ? this.mediaItem.videoUrl : this.mediaItem.imageUrl,
              notes: this.mediaItem.defaultCaption,
              location: 'media library'
            });
          } catch (adapterError) {
            this.errors.handleAdapter(adapterError, this.mediaItem);
            this.mediaItem.rollbackAttributes();
          }
          this.editingCaption = false;
          this.secondaryModal.removeModal();
        }
      }), null, "saveEditedCaption", "drop"));
    }
    get account() {
      return this.auth.currentAccount;
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get canNavigate() {
      return !(this.editingCaption || this.hasSecondary);
    }
    get canEditLabel() {
      return !this.currentGroup?.contributor;
    }
    get canDestroyMedia() {
      return !this.currentGroup?.contributor && this.mediaItem.approved;
    }
    get hasDirtyAttributes() {
      return this.mediaItem.get('dirtyType') === 'updated';
    }
    get hasSecondary() {
      return this.secondaryModal.isModalOpen();
    }
    get socialProfile() {
      return this.auth.currentSocialProfile;
    }
    get groupLabels() {
      const {
        group
      } = this.mediaItem;
      return this.store.peekAll('label').filter(label => label.get('group').get('id') === group.get('id'));
    }
    editGram(gram_id) {
      this.router.transitionTo('cluster.schedule.calendar.post.edit', gram_id);
    }
    navigate(isPositive) {
      this.mediaNavigation.navigate('cluster.media.edit', isPositive);
    }
    setValue(_ref) {
      let {
        code
      } = _ref;
      if (this.account?.canAccessCaptionHashtagSuggestions && !_constants.KEYBOARD_ARROW_KEYCODES.includes(code)) {
        this.scheduleCaptionHashtags.refetchCaptionHashtags.perform(this.socialProfile.id, this.mediaItem.defaultCaption);
      }
    }
    toggleCaptionTemplate() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.SAVED_CAPTIONS);
    }
    toggleSecondary(type, location) {
      this.secondaryModal.toggleModal(this.uniqueId, type, location);
    }
    toggleSmartHashtags() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.SMART_HASHTAGS);
    }
    toggleCaptionWriter() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.CAPTION_WRITER);
    }
    toggleHighPerformer() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.HIGH_PERFORMER);
    }
    toggleStarred() {
      if (this.mediaItem.isStarred) {
        this.starredMedia.removeStarred(this.mediaItem);
      } else {
        this.starredMedia.addStarred(this.mediaItem);
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "mediaLabels", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "scheduleCaptionHashtags", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "starredMedia", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "editingCaption", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "savedCaptionToEdit", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "mediaItem", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "editGram", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editGram"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "navigate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setValue", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCaptionTemplate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCaptionTemplate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSecondary", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSecondary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSmartHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSmartHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCaptionWriter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCaptionWriter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleHighPerformer", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleHighPerformer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleStarred", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleStarred"), _class.prototype)), _class));
  function _savedCaptionSegmentEvent2(eventName, savedCaptionTitle) {
    this.segment.track(eventName, {
      group_id: this.currentGroup?.id || null,
      location: 'media_item',
      saved_caption_title: savedCaptionTitle
    });
  }
});